$('.js-change-journey-filter').click(function () {

  reloadContainer('#js-ajax-journey-list', '/mywikinger/journey/ajax-journey-list?type=' + $(this).val());

});

function modalJourneyCancelShow(element) {
  let bookingNumber = element.getAttribute('data-booking-number');
  $("#modal-confirm-cancel-query-" + bookingNumber).modal("show");
}

function modalJourneyConfirmShow(element) {
  let bookingNumber = element.getAttribute('data-booking-number');
  $("#modal-confirm-option-" + bookingNumber).modal("show");
}
